import React, { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import { TextField, InputAdornment, IconButton, Tooltip } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { MuiPickersUtilsProvider, KeyboardDatePicker, } from '@mui/pickers';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function MDTextField(props) {
  const [value, setValue] = useState(props.value);
  const [summary, setSummary] = useState(props.summary);
  const [disabled, setDisabled] = useState(props.disabled);
  const [required, setRequired] = useState(props.required);
  const [error, setError] = useState(props.error);
  const [errorText, setErrorText] = useState(props.errorText);
  
  const [checkpattern, setcheckpattern] = useState(false);
  const [showId, setshowId] = useState(false);

  const isLocalChange = useRef(false);

  const { name, label, type, inputProps, inputLabelProps, multiline, wide, currency,locator,thirdpartylocator,mailshiplocator } = props

  useEffect(() => {
    setValue(props.value)
  }, [props.value])
  useEffect(() => {
    setSummary(props.summary)
  }, [props.summary])
  useEffect(() => {
    setDisabled(props.disabled)
  }, [props.disabled])
  useEffect(() => {
    if(props.error !== undefined) {
      setError(props.error)
      setErrorText(props.errorText)
    }
  }, [props.error])
  useEffect(() => {
    if(props.errorText !== undefined) {
      setErrorText(props.errorText)
    }
  }, [props.errorText])
  useEffect(() => {
      setRequired(props.required)
      setError(props.required? undefined : false)
      setErrorText(props.required? undefined : '')
  }, [props.required])

  // const currentYear = dayjs().year();
  // console.log("days curr year " + currentYear);
  // constructor(props) {
  //   super(props);
  //   this.state = {name: props.name, label: props.label, value: props.value, type: props.type, inputProps: props.inputProps,
  //          inputLabelProps: props.inputLabelProps, summary: props.summary, disabled: props.disabled, required: props.required,
  //          error: props.error, errorText: props.errorText, checkpattern: false, showId:false};
  // }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   if(nextProps.value !== prevState.value) {
  //     return { value: nextProps.value }
  //   } if(nextProps.summary !== prevState.summary) {
  //     return { summary: nextProps.summary }
  //   } if(nextProps.disabled !== prevState.disabled) {
  //     return { disabled: nextProps.disabled }
  //   } if(nextProps.error !== undefined && (nextProps.error !== prevState.error)) {
  //     return { error: nextProps.error, errorText: nextProps.errorText }
  //   } if(nextProps.errorText !== undefined && (nextProps.errorText !== prevState.errorText)) {
  //     return { errorText: nextProps.errorText }
  //   } if(nextProps.required !== prevState.required) {
  //     return { required: nextProps.required, error: nextProps.required? undefined : false, errorText: nextProps.required? undefined : '' }
  //   } else return null;
  // }

  const validateInput = (propertyName) => (event) => {
    handleChange(propertyName)(event)
    if (required) {
      if (event.target.value === '') {
        setError(true)
        setErrorText('Required Field. Please enter a value.')
        props.handleError(propertyName, true)
      } else {      
        setError(false)
        setErrorText('')
        props.handleError(propertyName, false)
      }
    }
  }

  // handleMouseDownIdentificationNumber = event => {
  //   event.preventDefault();
  // };

  const handleClickShowIdentificationNumber = () => { 
    setshowId(!showId)
  }

  const validateDateInput = (propertyName) => (event) => {
    // const value = event.target.value;
    if(value !== null && value.toString() === 'Invalid Date') {
        setErrorText('Required Field. Please enter a valid date.')
    } else {
      props.handleError('datecomp', false)
    }
  }

  const handleChange = (propertyName) => (event) => {
    // eslint-disable-next-line
    let checknamepattern = /[~@()+!#$%\^&*+=\\[\]\\;,/{}|\\":<>\?]/
    // eslint-disable-next-line
    let checkotherpattern = /[~`@()+!_#$%\^&*+=\\[\]\\';,/{}|\\":<>\?]/
    // eslint-disable-next-line
    let check_non_english_character = /[^\u0000-\u007F]/
    
    if((propertyName==='first' || propertyName==='last' || propertyName==='middle' || propertyName==='business' || 
        propertyName==='signName' || propertyName==='signTitle' || propertyName==='carrierName')&& event.target.value!==undefined) {
        if((checknamepattern.test(event.target.value) || (check_non_english_character).test(event.target.value))) {
          setcheckpattern(true)
        } else {   
          // console.log("field name/value " + propertyName + ' ' + event.target.value)
          setValue(event.target.value)
          setcheckpattern(false)
          setError(false)
          props.handleChange(propertyName, event.target.value);
        } 
      } else if ((propertyName==='passport'|| propertyName==='idnum' || propertyName==='alienNumber' || propertyName==='houseNumber' || 
          propertyName==='streetName' || propertyName==='city' || propertyName==='othercity'|| propertyName==='state' || propertyName==='country' || propertyName==='visaIssued' || 
          propertyName==='zip' || propertyName==='departurePort' || propertyName==='arrivePort' || propertyName==='methodOfShipment') && event.target.value!==undefined) {
        if((checkotherpattern.test(event.target.value) || (check_non_english_character).test(event.target.value) )) {
          setcheckpattern(true)
        } else { 
          setValue(event.target.value)
          setcheckpattern(false)
          setError(false)
          props.handleChange(propertyName, event.target.value);
        } 
    }  else {
      setValue(event.target.value)
      setError(false)
      props.handleChange(propertyName, event.target.value);
    }

    if (required && propertyName !== 'dob' && propertyName !== 'visaDate' && propertyName !== 'shipDate') {
      if (event.target.value !== '') {   
        props.handleError(propertyName, false)
      }
    }
  }

  const handleDateChange = (propertyName) => (date) => {
    setValue(date); // date is a dayjs object or null

    const isValid = date && date.isValid();
    const isInRange = isValid && !date.isBefore(dayjs().subtract(150, 'year')) && !date.isAfter(dayjs());

    if (required) {
      if (!date || !date.isValid()) {
        setError(true);
        setErrorText('Required Field. Please enter a valid date.');
        props.handleError(propertyName, true);
      } else if (!isInRange) {
        setError(true);
        setErrorText('No future date and past date needs to be within 150 years.');
        props.handleError(propertyName, true);
      } else {
        setError(false);
        setErrorText('');
        props.handleError(propertyName, false);
      }
    }

    // Only propagate the change to parent when fully cleared (null) or a fully valid date in range.
    // This prevents intermediate incomplete dates (e.g. year "0002" during typing) from causing parent errors or cursor jumps.
    if (date === null || isInRange) {
      isLocalChange.current = true;
      props.handleChange(propertyName, date ? date.toDate() : null);
    }
  };

  const sxProps = {
    ml: 1,
    mr: 1,
  };

  if (summary) {
    sxProps['& input'] = { color: '#000000' };
    sxProps['& textarea'] = { color: '#000000' };
  } else {
    sxProps['& label'] = { color: '#525252' };
    sxProps['& label span'] = { color: '#9C2F36' };
  }

  if (summary && wide) { // textFieldAddressSummary
    sxProps.width = { xs: '15rem', sm: '37.8rem' };
  } else if (summary && currency) { // textFieldCurrencySummary
    sxProps.width = { xs: '4rem', sm: '8rem' };
  } else if (wide) { // textFieldAddress
    sxProps.width = { xs: '15rem', sm: '32rem', md: '37.8rem' };
  } else if (currency) { // textFieldCurrency
    sxProps.width = '8rem';
  } else if (summary) { // textFieldSummary
    sxProps.width = '12rem';
  } else { // textField (default)
    sxProps.width = { xs: '15rem', sm: '12rem' };
  }

  return (
    <div>
      {type !== 'date' && !checkpattern &&
           <TextField
            sx={sxProps}
            name={props.name} 
            label={props.label}
            value={value}
            onChange={handleChange(name)} 
            onBlur={validateInput(name)} 
            error={error} 
            helperText={errorText} 
            margin='normal'
            id={locator==='Review'?name+locator:thirdpartylocator==='thirdparty'?name+thirdpartylocator:mailshiplocator==='mailship'?name+mailshiplocator:name} 
            required={required} 
            multiline={multiline}
            disabled={summary || disabled}
            type={props.name==='idnum'?showId?"text":"password":props.type}
            variant="standard"
            InputLabelProps={inputLabelProps}
            slotProps={{
              htmlInput: inputProps,
              inputProps: inputProps,
              input: {
                endAdornment: name === 'idnum' ? (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={handleClickShowIdentificationNumber}
                  >
                    {showId ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ) : undefined
              },
            }}
          />    
      }

      {type !== 'date' && checkpattern && 
        <Tooltip  title= 'Special characters are not allowed'  arrow aria-label="Special characters" >     
        <TextField 
            sx={sxProps}
            name={props.name} 
            label={props.label}             
            value={value}
            onChange={handleChange(name)} 
            onBlur={validateInput(name)} 
            error={error}            
            helperText={errorText} 
            margin='normal' 
            id={locator==='Review'?name+locator:thirdpartylocator==='thirdparty'?name+thirdpartylocator:mailshiplocator==='mailship'?name+mailshiplocator:name} 
            required={required} 
            multiline={multiline} 
            disabled={summary || disabled}
            type={props.name==='idnum'?showId?"text":"password":props.type}
            variant="standard"
            InputLabelProps={inputLabelProps}
            InputProps={{
              inputProps: inputProps,
              endAdornment:
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={handleClickShowIdentificationNumber}
                  >
                    {showId ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
            }}
        /> 
        </Tooltip> 
      }

      {type === 'date' &&
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker 
            sx={sxProps}
            label={props.label}
            value={value ? dayjs(value) : null}
            onChange={handleDateChange(name)}
            disabled={summary || disabled}
            disableFuture={true}
            minDate={dayjs().subtract(150, 'year')}
            maxDate={dayjs()}
            format="MM/DD/YYYY"
            slotProps={{
              textField: {
                variant: "standard",
                required: required,
                error: error,
                helperText: errorText,
                name: name,
                id: locator === 'Review' ? name + locator : thirdpartylocator === 'thirdparty' ? name + thirdpartylocator : mailshiplocator === 'mailship' ? name + mailshiplocator : name,
              },
              field: { clearable: true },
            }}
          />
        </LocalizationProvider>
      }

  </div>
  );
}

export default MDTextField;